import Bullet from "../Enemy/weapons/bullet.js";
import { GameConfig } from "./GameConfig.js";

const Weapons = {
    bullet: Bullet,
};

export const EnemyWeaponConfig = {
    Bullet: {
        IMG_SRC: "./assets/enemy/weapons/bullet.png",

        SPRITE_WIDTH: 24,
        SPRITE_HEIGHT: 18,

        MAX_FRAME: 7,

        SPEED: -10,
        DAMAGE: 10,
    },
};

export const EnemyConfig = {
    SPAWN_BUFFER_DISTANCE_PX: 100,

    ShipFighter: {
        IMG_SRC_FLY: "./assets/enemy/ship-fighter/ship-fighter.png",
        IMG_SRC_DEATH: "./assets/enemy/ship-fighter/ship-fighter-death.png",

        SPRITE_WIDTH: 128,
        SPRITE_HEIGHT: 64,

        HEALTH: 10,

        MIN_SPEED: -5,
        MAX_SPEED: -5,

        ENEMY_SCORE: 5,
        ENEMY_DAMAGE: 10,

        MIN_Y_POS: 10,
        MAX_Y_POS: GameConfig.CANVAS_HEIGHT / 2,

        MAX_FRAME_FLY: 0,
        MAX_FRAME_DEATH: 7,

        CAN_ATTACK: false,

        BURST: {
            IMG_SRC: "./assets/enemy/ship-fighter/ship-fighter-burst.png",
            SPRITE_WIDTH: 128,
            SPRITE_HEIGHT: 128,
            MAX_FRAME: 7,
        },

        RARITY: 10,
    },
    DreadNought: {
        IMG_SRC_FLY: "./assets/enemy/dreadnought/dreadnought.png",
        IMG_SRC_DEATH: "./assets/enemy/dreadnought/dreadnought-death.png",

        SPRITE_WIDTH: 256,
        SPRITE_HEIGHT: 144,

        HEALTH: 50,

        MIN_SPEED: -1,
        MAX_SPEED: -2,

        ENEMY_SCORE: 100,
        ENEMY_DAMAGE: 100,

        CAN_ATTACK: true,

        MIN_Y_POS: GameConfig.CANVAS_HEIGHT / 2 - 100,
        MAX_Y_POS: GameConfig.CANVAS_HEIGHT / 2 + 100,

        MAX_FRAME_FLY: 0,
        MAX_FRAME_DEATH: 11,

        ATTACK_TIMER: 0,
        ATTACK_INTERVAL_MIN: 2000, // milliseconds
        ATTACK_INTERVAL_MAX: 5000, // milliseconds

        BURST: {
            IMG_SRC: "./assets/enemy/dreadnought/dreadnought-burst.png",
            SPRITE_WIDTH: 256,
            SPRITE_HEIGHT: 256,
            MAX_FRAME: 7,
        },

        WEAPONS: [Weapons.bullet],
        RARITY: 1,
    },
};

export const EnemyStateConfig = {
    FLY: 0,
    DEATH: 1,
    ATTACK: 2,
};
